export default {
    name: 'iki',
    logo: require('./assets/logoIki.png'),
    helpEmail: 'ikikiuas@ikikiuas.fi',
    fontFamily: 'Manrope',
    secondaryFontFamily: 'Manrope',
    serverCost: 29,
};
